import React, {Component} from 'react'
import {connect} from "react-redux";
import {Grid} from "react-bootstrap";
import PageTitle from "../../../../common/page-title";
import '../../../products/common/styles.css'
import ArrowButton from "../../../../common/button-arrow";
import {Link} from "react-router-dom";
import UpsellPopupsSearchPanel from './upsell-popups-search-panel';
import {getUpsellPopups} from '../../../../../actions/upsell_popups'
import withInputChange from "../../../../withInputChange";
import UpsellPopupsList from "./upsell-popup-list";

class UpsellPopups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      product: ''
    }
  }

  componentDidMount() {
    this.onApply();
  }

  onApply = () => {
    const {product} = this.props.fields;
    this.props.dispatch(getUpsellPopups(product));
  };

  render() {
    const {
      productList, handleChange, handleClearFilters, upsell_popups, fetching, fetched, fields
    } = this.props;

    return (
      <Grid bsClass="container" fluid className="products accordion">
        <PageTitle>Upsell Popups</PageTitle>
        <Link to="/admin/upsell_popups/new">
          <div className="mg-bottom-20">
            <ArrowButton
              color="red"
              className="add-upsell-popup"
              submit={false}
              arrow={false}
              permissions={{
                action: 'new',
                subjectClass: 'UpsellPopup'
              }}
            >
              New Upsell Popup
            </ArrowButton>
          </div>
        </Link>
        <UpsellPopupsSearchPanel
          productValue={fields.product}
          onProductChange={handleChange('product')}
          productList={productList}
          onApply={this.onApply}
          onClearFilters={handleClearFilters(this.onApply)}
        />
        <UpsellPopupsList
          upsell_popups={upsell_popups}
          fetching={fetching}
          fetched={fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  upsell_popups: state.upsellPopups.upsell_popups,
  productList: state.upsellPopups.productList,
  fetched: state.upsellPopups.fetched,
  fetching: state.upsellPopups.fetching
});

const initialState = {
  product: ''
};

export default connect(mapStateToProps)(withInputChange(initialState)(UpsellPopups));



// WEBPACK FOOTER //
// ./src/components/admin/promotions/upsell_popups/list/index.jsx